import { render, staticRenderFns } from "./PlayerListComponent.vue?vue&type=template&id=482178a8&"
import script from "./PlayerListComponent.vue?vue&type=script&lang=js&"
export * from "./PlayerListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports